export enum AdditionalInfoFieldType {
    TextArea = 0,
    DatePicker = 1,
    TimePicker = 2,
    DropDownList = 3,
    MultiSelect = 4,
    Switch = 5,
}

// Alias for compatibility with components
export type FieldType = AdditionalInfoFieldType;

export interface UniqueString {
  Value: string;   // C# JsonPropertyName("Value")
  Id: string;      // GUID as string (C# JsonPropertyName("Id"))
}

export interface DDCell {
  id: string;                  // Unique identifier for each cell
  header: string;
  tempData: UniqueString[];    // matches List<UniqueString>
  selection: string[];         // List<string>
  text: string;
  date: Date;                  // ISO date string (from Date in C#)
  state: boolean;
  type: AdditionalInfoFieldType;
  rowNumber: number;
}

export interface DDRow {
  id: string;                  // Unique identifier for each row
  cells: DDCell[];             // matches List<DDCell>
}

